import { useCallback } from 'react';

import { AccountDrawerType, performApiLogout, usePageLayout } from '@libs/common-next';
import { evaluateSession, isLastActiveExpired, isUserLoggedIn } from '@libs/core';

export const useSoftLoginGuard = () => {
    const { openAccountDrawer, setSignInDrawerProps } = usePageLayout();

    const authGuard = useCallback(
        async (callback: () => void) => {
            const endedByInactivity = isLastActiveExpired();
            const sessionStillValid = await evaluateSession({ skipRedirect: true, performApiLogout });

            if (isUserLoggedIn()) {
                callback();
                return;
            }

            // Revoked Auth0 sessions start a top-level /v2/logout; don't open sign-in over it.
            if (!sessionStillValid && !endedByInactivity) {
                return;
            }

            openAccountDrawer(AccountDrawerType.SIGN_IN);
            setSignInDrawerProps({
                onSuccess: callback,
            });
        },
        [openAccountDrawer, setSignInDrawerProps]
    );

    return {
        authGuard,
    };
};
